module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/arezzo.d83d4e202ebccda1621aef6b9e82b16f.jpg";